import React from 'react'
import BIQuestions from './BIQuestions'

const BusinessIntelligence = ({ data }) => {
    return (
        data?.map((busData, BusIndex) => <div key={BusIndex}>
            <h3 className='paragraph'><b>{busData?.title}</b></h3>
            {busData?.paragraph?.map((item, index) => {
                return (
                    <div key={index} className='businessListCardDiv'>
                        <p className="paragraph">{item?.para}<b>{item?.paraBold}</b>{item?.para1}</p>
                        <div className='businessCard'>
                            <BIQuestions data={item?.list} />
                        </div>
                    </div>
                )
            })
            }
        </div>)
    )
}
export default BusinessIntelligence
